export const TERM_OPTIONS = ['Term One', 'Term Two', 'Term Three'];

export const ASSESSMENT_TYPES = [
  'Monthly Test',
  'Mid-Term Test',
  'End of Term Test'
];

